
//本机测试
//上传
/*
export const FIEL_UPLOAD="http://192.168.83.23:31899/testfileUpload"
//下载
export const FIEL_DOWNLOAD='http://192.168.83.23:31899/testdownload'
export const WWFIEL_DOWNLOAD='http://192.168.83.23:31899/testdownload'
export const FASTDFS_URL='http://192.168.123.207:8888'
//测试服务器地址
export const BASE_URL="http://192.168.83.23:31899/callProvider"
//fme server
export const FMESERVER_URL="http://192.168.123.204:6080/"
export const SPACE_URL="http://172.31.1.166:31899/callProvider"
export const GIS_URL="http://192.165.122.223:31899/callProvider"
export const WECHAT_CALL_URL="http://192.168.123.206:8080/MobileBuilder/dchy.html"
export const MAP_URL="http://172.31.1.156:8080/onemapV5.0/main.html?"+btoa(encodeURIComponent("loginName=admin&psw=1&ua=1&full=1"))
*/

/*223测试服务器*/
//上传
/*

export const FIEL_UPLOAD="http://192.165.122.223:31899/testfileUpload"
//下载
export const FIEL_DOWNLOAD='http://192.165.122.223:31899/testdownload'
export const WWFIEL_DOWNLOAD='http://192.165.122.223:31899/testdownload'
export const FASTDFS_URL='http://192.168.123.207:8888'
//测试服务器地址
export const BASE_URL="http://192.165.122.223:31899/callProvider"
//fme server
export const FMESERVER_URL="http://192.168.123.204:6080/"
export const SPACE_URL="http://172.31.1.166:31899/callProvider"
export const MAP_URL="http://172.31.1.156:8080/onemapV5.0/main.html?"+btoa(encodeURIComponent("loginName=admin&psw=1&ua=1&full=1"))
//微信回调地址
export const WECHAT_CALL_URL="http://192.168.123.206:8080/MobileBuilder/dchy.html"
*/


//外网安全域正式环境

export const BASE_URL="http://111.21.167.150:31899/callProvider"
export const FIEL_UPLOAD="http://111.21.167.150:31899/fileUpload"
export const FIEL_DOWNLOAD="http://111.21.167.150:31899/download"
export const WWFIEL_DOWNLOAD="http://111.21.167.150:31899/testdownload"
export const GIS_URL="http://10.10.10.35:31899/callProvider"
export const FMESERVER_URL="http://172.31.1.178:6060"
export const FASTDFS_URL='http://111.21.202.218:8888'
export const WECHAT_CALL_URL="http://zyghj.yl.gov.cn/MobileBuilder/dchy.html"









// WEBPACK FOOTER //
// ./src/api/url.js